<div class="lob-model-vie">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb" style="margin-bottom: 0px;padding-top: 1.5%;">
      <li class="breadcrumb-item"><a [routerLink]="['/landing-page']"> Home </a></li>
      <li class="breadcrumb-item active" aria-current="page">Admin Dashboard</li>
    </ol>
  </nav>
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font" style="padding-left:14px ; width: 100%;">
      <div class="row1">
        @if (hasAccess || hasUserRoleChangeAccess || hasReportAdminAccess || hasReportWfAccess) {
        <div class="uitk-l-grid__col--20 admin-jobs-tab">
          @if (showLoader) {
          <div class="stk-table-loader">
            <app-loader></app-loader>
          </div>
          }
          <mat-tab-group class="Admintabs" [selectedIndex]="Activetab">
            @if (hasUserRoleChangeAccess) {
            <mat-tab class="mat-tab-label" label="User Access Management">
              <app-user-access-search></app-user-access-search>
            </mat-tab>
            } @if (hasAccess) {
            <mat-tab class="mat-tab-label" label="Refresh Jobs">
              <div class="container">
                @if (showJobLoader) {
                <div class="stk-table-loader">
                  <app-loader> </app-loader>
                </div>
                } @if (!showJobLoader) {
                <div>
                  <div class="job-section">
                    <div class="job-section-header">
                      <button
                        mat-icon-button
                        type="button"
                        class="expand-all-button"
                        [attr.aria-label]="
                          isScheduledRefreshJobsExpanded
                            ? 'Collapse Scheduled Refresh Jobs'
                            : 'Expand Scheduled Refresh Jobs'
                        "
                        (click)="isScheduledRefreshJobsExpanded = !isScheduledRefreshJobsExpanded"
                      >
                        <mat-icon class="expansion-icon">{{
                          isScheduledRefreshJobsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                        }}</mat-icon>
                      </button>
                      <button
                        type="button"
                        class="job-section-title"
                        (click)="isScheduledRefreshJobsExpanded = !isScheduledRefreshJobsExpanded"
                      >
                        Daily sync jobs
                      </button>
                    </div>
                    @if (isScheduledRefreshJobsExpanded) {
                    <div>
                      <div class="job-sub-section">
                        <div class="job-sub-section-header bg-danger-subtle">
                          <button
                            mat-icon-button
                            type="button"
                            class="expand-all-button"
                            [attr.aria-label]="isFailedJobsExpanded ? 'Collapse Failed Jobs' : 'Expand Failed Jobs'"
                            (click)="isFailedJobsExpanded = !isFailedJobsExpanded"
                          >
                            <mat-icon class="expansion-icon">{{
                              isFailedJobsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                            }}</mat-icon>
                          </button>
                          <button
                            type="button"
                            class="job-sub-section-title"
                            (click)="isFailedJobsExpanded = !isFailedJobsExpanded"
                          >
                            Failed Jobs ({{ fcount }})
                          </button>
                        </div>
                        @if (isFailedJobsExpanded) {
                        <div>
                          <div class="job-table-scroll">
                            <table
                              mat-table
                              [dataSource]="F_dataSource"
                              multiTemplateDataRows
                              class="refresh-job-table"
                            >
                              <ng-container matColumnDef="jobName">
                                <th mat-header-cell *matHeaderCellDef class="header">Job Name</th>
                                <td mat-cell *matCellDef="let app">
                                  <div class="job-name-cell">
                                    <button
                                      mat-icon-button
                                      type="button"
                                      class="expand-all-button job-row-expand-button"
                                      [attr.aria-label]="
                                        expandedFailedJob === app
                                          ? 'Collapse failed job details'
                                          : 'Expand failed job details'
                                      "
                                      (click)="toggleFailedJob(app); $event.stopPropagation()"
                                    >
                                      <mat-icon class="expansion-icon">{{
                                        expandedFailedJob === app ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                                      }}</mat-icon>
                                    </button>
                                    <span class="job-name-text">{{ app.type }}</span>
                                  </div>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="jobType">
                                <th mat-header-cell *matHeaderCellDef class="header">Job Type</th>
                                <td mat-cell *matCellDef="let app">{{ app.job_type }}</td>
                              </ng-container>
                              <ng-container matColumnDef="refreshTime">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">
                                  Last Refresh Date
                                </th>
                                <td mat-cell *matCellDef="let app" style="width:15%;">
                                  {{ getLastRefreshDate(app) | date: 'dd/MM/yyyy,h:mm a' }}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="triggeredby">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">
                                  Triggered By
                                </th>
                                <td mat-cell *matCellDef="let app" style="width:15%;">{{ app.triggeredby }}</td>
                              </ng-container>
                              <ng-container matColumnDef="Schedule">
                                <th mat-header-cell *matHeaderCellDef style="width:10%;" class="header">Schedule</th>
                                <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Schedule }}</td>
                              </ng-container>
                              <ng-container matColumnDef="Params">
                                <th mat-header-cell *matHeaderCellDef style="width:20%;" class="header">Parameters</th>
                                <td mat-cell *matCellDef="let app; let i = dataIndex" style="width:20%;">
                                  <div
                                    class="job-params"
                                    (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()"
                                  >
                                    @if (checkParamType(app, 'Date')) {
                                    <mat-form-field color="accent" appearance="fill">
                                      <mat-label>Choose a date</mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="failedPicker"
                                        (dateInput)="addDateEvent($event, app, i)"
                                        [max]="maxDate"
                                      />
                                      <mat-datepicker-toggle matSuffix [for]="failedPicker"> </mat-datepicker-toggle>
                                      <mat-datepicker #failedPicker></mat-datepicker>
                                    </mat-form-field>
                                    } @if (checkParamType(app, 'Year')) {
                                    <div color="accent" appearance="fill">
                                      <mat-form-field>
                                        <mat-label>Select Year</mat-label>
                                        <mat-select
                                          name="my-select"
                                          [(ngModel)]="selectedYear"
                                          (selectionChange)="selectChange(app, i)"
                                          style="width: 130px;"
                                        >
                                          @for (item of yearValues; track item) {
                                          <mat-option [value]="item.name" style="text-align: center;">
                                            {{ item.name }}
                                          </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    } @if (checkParamType(app, 'tableName')) {
                                    <div color="accent" appearance="fill">
                                      <mat-form-field>
                                        <mat-label>Select Table</mat-label>
                                        <mat-select
                                          name="my-select"
                                          [(ngModel)]="selectedTable"
                                          (selectionChange)="tableNameChange(i)"
                                          style="width: 130px;"
                                        >
                                          @for (item of tableName; track item) {
                                          <mat-option [value]="item.name" style="text-align: center;">
                                            {{ item.name }}
                                          </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    } @if ((app.type == 'EP-Delta-refresh') && showHoursMessage) {
                                    <div class="showEpDeltaRefreshMessage">
                                      Selected date can't be greater than 72 hours.
                                    </div>
                                    }
                                  </div>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="Action">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">Action</th>
                                <td mat-cell *matCellDef="let app; let i = dataIndex" style="width:15%; ">
                                  <span
                                    class="trigger-button-wrapper"
                                    [attr.title]="isAdbTrigger(app) ? invalidEndpointMessage : null"
                                  >
                                    <button
                                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
                                      [disabled]="disableTrigger || isAdbTrigger(app)"
                                      (click)="submit_error(app, i, $event)"
                                    >
                                      Trigger
                                    </button>
                                  </span>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let app" [attr.colspan]="fdisplayedColumns.length">
                                  @if (expandedFailedJob === app) {
                                  <div class="job-detail-wrapper">
                                    <table class="job-detail-table failed-job-detail-table">
                                      <thead>
                                        <tr>
                                          <th class="header job-detail-table-name">Table Name</th>
                                          <th class="header job-detail-count">Table Row Count</th>
                                          <th class="header job-detail-update-count">Update Count</th>
                                          <th class="header job-detail-error">Error</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td class="job-detail-table-name">
                                            @for (tableName of splitCommaSeparatedValue(app.table_name); track
                                            tableName) {
                                            <div>{{ tableName }}</div>
                                            }
                                          </td>
                                          <td class="job-detail-count">
                                            @for (tableRowCount of splitCommaSeparatedValue(app.table_row_count); track
                                            tableRowCount) {
                                            <div>{{ tableRowCount }}</div>
                                            }
                                          </td>
                                          <td class="job-detail-update-count">
                                            @for (updateCount of splitCommaSeparatedValue(app.update_count); track
                                            updateCount) {
                                            <div>{{ updateCount }}</div>
                                            }
                                          </td>
                                          <td class="job-detail-error">
                                            {{
                                              app.Error ||
                                                'Automated job failed during refresh processing due to an unexpected upstream API timeout or database transaction interruption. No detailed exception was captured in the log. Please review application logs, API response status, retry history, and database connectivity for the exact failure reason.'
                                                | slice: 0:300
                                            }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  }
                                </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="fdisplayedColumns"></tr>
                              <tr
                                mat-row
                                *matRowDef="let row; columns: fdisplayedColumns"
                                class="job-main-row"
                                (click)="toggleFailedJob(row)"
                              ></tr>
                              <tr
                                mat-row
                                *matRowDef="let row; columns: expandedDetailColumns"
                                class="job-detail-row"
                                [class.hide-detail-row]="expandedFailedJob !== row"
                              ></tr>
                            </table>
                          </div>
                        </div>
                        }
                      </div>
                      <div class="job-sub-section">
                        <div class="job-sub-section-header bg-success-subtle">
                          <button
                            mat-icon-button
                            type="button"
                            class="expand-all-button"
                            [attr.aria-label]="isSuccessJobsExpanded ? 'Collapse Success Jobs' : 'Expand Success Jobs'"
                            (click)="isSuccessJobsExpanded = !isSuccessJobsExpanded"
                          >
                            <mat-icon class="expansion-icon">{{
                              isSuccessJobsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                            }}</mat-icon>
                          </button>
                          <button
                            type="button"
                            class="job-sub-section-title"
                            (click)="isSuccessJobsExpanded = !isSuccessJobsExpanded"
                          >
                            Success Jobs ({{ scount }})
                          </button>
                        </div>
                        @if (isSuccessJobsExpanded) {
                        <div>
                          <div class="job-table-scroll">
                            <table
                              mat-table
                              [dataSource]="S_dataSource"
                              multiTemplateDataRows
                              class="refresh-job-table"
                            >
                              <ng-container matColumnDef="jobName">
                                <th mat-header-cell *matHeaderCellDef class="header">Job Name</th>
                                <td mat-cell *matCellDef="let app">
                                  <div class="job-name-cell">
                                    <button
                                      mat-icon-button
                                      type="button"
                                      class="expand-all-button job-row-expand-button"
                                      [attr.aria-label]="
                                        expandedSuccessJob === app
                                          ? 'Collapse success job details'
                                          : 'Expand success job details'
                                      "
                                      (click)="toggleSuccessJob(app); $event.stopPropagation()"
                                    >
                                      <mat-icon class="expansion-icon">{{
                                        expandedSuccessJob === app ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                                      }}</mat-icon>
                                    </button>
                                    <span class="job-name-text">{{ app.type }}</span>
                                  </div>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="jobType">
                                <th mat-header-cell *matHeaderCellDef class="header">Job Type</th>
                                <td mat-cell *matCellDef="let app">{{ app.job_type }}</td>
                              </ng-container>
                              <ng-container matColumnDef="refreshTime">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">
                                  Last Refresh Date
                                </th>
                                <td mat-cell *matCellDef="let app" style="width:15%;">
                                  {{ getLastRefreshDate(app) | date: 'dd/MM/yyyy,h:mm a' }}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="triggeredby">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">
                                  Triggered By
                                </th>
                                <td mat-cell *matCellDef="let app" style="width:15%;">{{ app.triggeredby }}</td>
                              </ng-container>
                              <ng-container matColumnDef="Schedule">
                                <th mat-header-cell *matHeaderCellDef style="width:10%;" class="header">Schedule</th>
                                <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Schedule }}</td>
                              </ng-container>
                              <ng-container matColumnDef="Params">
                                <th mat-header-cell *matHeaderCellDef style="width:20%;" class="header">Parameters</th>
                                <td mat-cell *matCellDef="let app; let i = dataIndex" style="width:20%;">
                                  <div
                                    class="job-params"
                                    (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()"
                                  >
                                    @if (checkParamType(app, 'Date')) {
                                    <mat-form-field color="accent" appearance="fill">
                                      <mat-label>Choose a date</mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="successPicker"
                                        (dateInput)="addDateEvent($event, app, i)"
                                        [max]="maxDate"
                                      />
                                      <mat-datepicker-toggle matSuffix [for]="successPicker"> </mat-datepicker-toggle>
                                      <mat-datepicker #successPicker></mat-datepicker>
                                    </mat-form-field>
                                    } @if (checkParamType(app, 'Year')) {
                                    <div color="accent" appearance="fill">
                                      <mat-form-field>
                                        <mat-label>Select Year</mat-label>
                                        <mat-select
                                          name="my-select"
                                          [(ngModel)]="selectedYear"
                                          (selectionChange)="selectChange(app, i)"
                                          style="width: 130px;"
                                        >
                                          @for (item of yearValues; track item) {
                                          <mat-option [value]="item.name" style="text-align: center;">
                                            {{ item.name }}
                                          </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    } @if (checkParamType(app, 'tableName')) {
                                    <div color="accent" appearance="fill">
                                      <mat-form-field>
                                        <mat-label>Select Table</mat-label>
                                        <mat-select
                                          name="my-select"
                                          [(ngModel)]="selectedTable"
                                          (selectionChange)="tableNameChange(i)"
                                          style="width: 130px;"
                                        >
                                          @for (item of tableName; track item) {
                                          <mat-option [value]="item.name" style="text-align: center;">
                                            {{ item.name }}
                                          </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    } @if ((app.type == 'EP-Delta-refresh') && showHoursMessage) {
                                    <div class="showEpDeltaRefreshMessage">
                                      Selected date can't be greater than 72 hours.
                                    </div>
                                    }
                                  </div>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="Action">
                                <th mat-header-cell *matHeaderCellDef style="width:15%;" class="header">Action</th>
                                <td mat-cell *matCellDef="let app; let i = dataIndex" style="width:15%; ">
                                  <span
                                    class="trigger-button-wrapper"
                                    [attr.title]="isAdbTrigger(app) ? invalidEndpointMessage : null"
                                  >
                                    <button
                                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
                                      [disabled]="disableTrigger || isAdbTrigger(app)"
                                      (click)="submit(app, i, $event)"
                                    >
                                      Trigger
                                    </button>
                                  </span>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="expandedDetail">
                                <td mat-cell *matCellDef="let app" [attr.colspan]="sdisplayedColumns.length">
                                  @if (expandedSuccessJob === app) {
                                  <div class="job-detail-wrapper">
                                    <table class="job-detail-table success-job-detail-table">
                                      <thead>
                                        <tr>
                                          <th class="header job-detail-table-name">Table Name</th>
                                          <th class="header job-detail-count">Table Row Count</th>
                                          <th class="header job-detail-update-count">Update Count</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td class="job-detail-table-name">
                                            @for (tableName of splitCommaSeparatedValue(app.table_name); track
                                            tableName) {
                                            <div>{{ tableName }}</div>
                                            }
                                          </td>
                                          <td class="job-detail-count">
                                            @for (tableRowCount of splitCommaSeparatedValue(app.table_row_count); track
                                            tableRowCount) {
                                            <div>{{ tableRowCount }}</div>
                                            }
                                          </td>
                                          <td class="job-detail-update-count">
                                            @for (updateCount of splitCommaSeparatedValue(app.update_count); track
                                            updateCount) {
                                            <div>{{ updateCount }}</div>
                                            }
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  }
                                </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="sdisplayedColumns"></tr>
                              <tr
                                mat-row
                                *matRowDef="let row; columns: sdisplayedColumns"
                                class="job-main-row"
                                (click)="toggleSuccessJob(row)"
                              ></tr>
                              <tr
                                mat-row
                                *matRowDef="let row; columns: expandedDetailColumns"
                                class="job-detail-row"
                                [class.hide-detail-row]="expandedSuccessJob !== row"
                              ></tr>
                            </table>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
                <br />
                <div class="job-section">
                  <div class="job-section-header">
                    <button
                      mat-icon-button
                      type="button"
                      class="expand-all-button"
                      [attr.aria-label]="
                        isCostRefreshJobsExpanded ? 'Collapse Cost Refresh Jobs' : 'Expand Cost Refresh Jobs'
                      "
                      (click)="isCostRefreshJobsExpanded = !isCostRefreshJobsExpanded"
                    >
                      <mat-icon class="expansion-icon">{{
                        isCostRefreshJobsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                      }}</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="job-section-title"
                      (click)="isCostRefreshJobsExpanded = !isCostRefreshJobsExpanded"
                    >
                      Cost Refresh Jobs
                    </button>
                  </div>
                  @if (isCostRefreshJobsExpanded) {
                  <div>
                    <div class="searchDiv">
                      <input
                        type="text"
                        class="search-option table-data-font search-box"
                        placeholder="Search"
                        (keyup)="MonthlyJobFilter($event.target.value)"
                      />
                      <img
                        class="search_Icon"
                        src="../../../../assets/images/searchicon.png"
                        style="position: relative;"
                      />
                    </div>
                    <div class="job-table-scroll">
                      <table mat-table [dataSource]="dataSourceMonthlyJobs" class="MonthlyTable cost-refresh-table">
                        <ng-container matColumnDef="Environment">
                          <th mat-header-cell *matHeaderCellDef class="smallColumn">Environment</th>
                          <td mat-cell *matCellDef="let job" class="smallColumn">{{ job.Environment }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Process_Level">
                          <th mat-header-cell *matHeaderCellDef style="text-align: left;">Main Stage</th>
                          <td mat-cell *matCellDef="let job" style="text-align: left;">{{ job.Process_Level }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Process_Name">
                          <th mat-header-cell *matHeaderCellDef style="text-align: left;">Sub Stage</th>
                          <td mat-cell *matCellDef="let job" style="text-align: left;">{{ job.Process_Name }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Year">
                          <th mat-header-cell *matHeaderCellDef class="smallColumn">Year</th>
                          <td mat-cell *matCellDef="let job" class="smallColumn">{{ job.Year }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Month">
                          <th mat-header-cell *matHeaderCellDef class="smallColumn">Month</th>
                          <td mat-cell *matCellDef="let job" class="smallColumn">{{ job.Month }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Start_Time">
                          <th mat-header-cell *matHeaderCellDef>Start Time</th>
                          <td mat-cell *matCellDef="let job" class="date">
                            {{ job.Start_Time | date: 'dd/MM/yyyy hh:mm a' }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="End_Time">
                          <th mat-header-cell *matHeaderCellDef>End Time</th>
                          <td mat-cell *matCellDef="let job">{{ job.End_Time | date: 'dd/MM/yyyy hh:mm a' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef class="smallColumn">Status</th>
                          <td mat-cell *matCellDef="let job" class="smallColumn">{{ job.Status }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsMonthlyJobs"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsMonthlyJobs"></tr>
                      </table>
                    </div>
                  </div>
                  }
                </div>
                <br />
              </div>
            </mat-tab>
            } @if (hasAccess) {
            <mat-tab class="mat-tab-label" label="Access">
              <div class="container">
                <table mat-table [dataSource]="dataSourceAdmin" class="mat-elevation-z8">
                  <ng-container matColumnDef="User_Name">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;">User Name</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.User_Name }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Msid">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%;">MSID</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Msid }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Justification">
                    <th mat-header-cell *matHeaderCellDef style="width:15%;">Justification Details</th>
                    <td title="{{ app.Justification }}" mat-cell *matCellDef="let app" style="width:15%;">
                      {{ app.Justification.length > 30 ? app.Justification.substr(0, 30) + '...' : app.Justification }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Page">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;">Page URI</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Page }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Tab">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;">Tab</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Tab }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Request_Type">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;">Request Type</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Request_Type }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Createdate">
                    <th mat-header-cell *matHeaderCellDef style="width:15%;">Last Updated Date</th>
                    <td mat-cell *matCellDef="let app" style="width:15%;">
                      {{ app.Updatedate ? app.Updatedate.substr(0, 10) : '' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Request_Status">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;">Status</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">{{ app.Request_Status }}</td>
                  </ng-container>
                  <ng-container matColumnDef="Action">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;" class="header">Action</th>
                    <td mat-cell *matCellDef="let app" style="width:10%;">
                      @if (app.Request_Status === 'Open') {
                      <span>
                        <img
                          style="margin-right: 5px; cursor: pointer;"
                          (click)="status('Approved', app)"
                          src="../../../../assets/images/correct.png"
                        />
                        <img
                          style=" cursor: pointer;"
                          (click)="status('Rejected', app)"
                          src="../../../../assets/images/reject.png"
                        />
                      </span>
                      } @if (app.Request_Status !== 'Open') {
                      <span>{{ ActionNA }}</span>
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsAdmin"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsAdmin"></tr>
                </table>

                <mat-paginator
                  #paginatorAdmin="matPaginator"
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                  aria-label="Select page of periodic elements"
                >
                </mat-paginator>
              </div>
            </mat-tab>
            } @if (hasAccess) {
            <mat-tab class="mat-tab-label" label="Dynamic Tables">
              <div class="lookupSection">
                <app-lookup-editor [lookupTables]="lookupTables"></app-lookup-editor>
              </div>
            </mat-tab>
            } @if (hasReportAdminAccess || hasReportWfAccess) {
            <mat-tab label="Report Management">
              <div class="lookupSection">
                <app-report-management
                  [hasReportWfAccess]="hasReportWfAccess"
                  [hasReportAdminAccess]="hasReportAdminAccess"
                ></app-report-management>
              </div>
            </mat-tab>
            }
            <!-- Bulk Templates tab is shown only if user has bulk template generation access -->
            @if (hasBulkTemplatesAccess) {
            <mat-tab label="Bulk Templates">
              <div class="lookupSection">
                <app-bulk-templates></app-bulk-templates>
              </div>
            </mat-tab>
            }
          </mat-tab-group>
        </div>
        }
      </div>
      <br />
    </div>
  </div>
</div>
